/** Max listings that can be selected for comparison at once. */
export const COMPARE_LIMIT = 4

/**
 * Below this the header card's footer stacks the amount above the actions.
 * A size container query measures the card's CONTENT box, so this excludes the
 * card's own padding and border — 232px here is a 250px card.
 *
 * Measured, not a design token: a six-figure amount is 103px, a currency chip
 * 31px, the two actions 86px, plus the gaps. Every compare column is the same
 * width, so all cards stack together rather than one card at a time.
 */
export const COMPARE_CARD_STACK_WIDTH = '232px'

/**
 * Marks a header card whose footer stacks whatever its width. A mixed-currency
 * set adds a currency chip beside the amount, and no card width fits a long
 * amount, the chip and both actions on one row — so every card stacks together
 * rather than only the card whose amount is too long.
 */
export const COMPARE_CARD_STACKED_ATTR = 'data-compare-stacked'
